import { defineStore } from 'pinia'
import useCustomFetch from '~/composables/useCustomFetch'

const apiProviderAdapters = {
    ['live_casino']: 'live_casino',
    ['tables']: 'table_game',
    ['slot']: 'slots',
    ['e_sport']: 'e-sport',
    ['fishing']: 'fishing',
    ['sport']: 'sport',
    ['virtual_sport']: 'virtual_sport',
    ['lotto']: 'lottery',
    ['quick_game']: 'quick_game',
    ['cock_fight']: 'cockfight',
}

export const PROVIDERS = {
    ['vivo']: {
        id: 'vivo',
        name: 'Vivo',
        link: '/casino/all?partner=vivo',
        image: '/assets/icons/casino/provider/vivo.png',
        icon: '/assets/icons/casino/provider/vivo-card.svg',
        key: 'vivo',
        sub: 'vivo',
        stt: 1,
    },
    ['pragmatic']: {
        id: 'pragmatic',
        name: 'Pragmatic',
        link: '/games/slots?partner=pragmatic',
        image: '/assets/img/slot/pragmatic.png',
        icon: '/assets/img/slot/pragmatic.svg',
        key: 'pragmatic',
        sub: 'pragmatic',
        stt: 3,
    },
    ['ezugi']: {
        id: 'ezugi',
        name: 'Ezugi',
        link: '/casino/all?partner=ezugi',
        image: '/assets/icons/casino/provider/ezugi.png',
        icon: '/assets/icons/casino/provider/ezugi-card.svg',
        key: 'ezugi',
        sub: 'ezugi',
        stt: 3,
    },
    ['evo']: {
        id: 'evo',
        name: 'Evolution',
        link: '/casino/all?partner=evo',
        image: '/assets/icons/casino/provider/evolution.png',
        icon: '/assets/icons/casino/provider/evolution-card.svg',
        key: 'evo',
        sub: 'evo',
        stt: 4,
    },
    ['mg']: {
        id: 'mg',
        name: 'Microgaming',
        link: '/casino/all?partner=mg',
        image: '/assets/img/slot/microgaming.png',
        icon: '/assets/img/slot/microgaming.svg',
        key: 'mg',
        sub: 'mg',
        stt: 5,
    },
    ['ebet']: {
        id: 'ebet',
        name: 'Ebet',
        link: '/casino/all?partner=ebet',
        image: '/assets/icons/casino/provider/ebet.png',
        icon: '/assets/icons/casino/provider/ebet-card.svg',
        key: 'ebet',
        sub: 'ebet',
    },
    ['yeebet']: {
        id: 'yeebet',
        name: 'Yeebet',
        link: '/casino/all?partner=yeebet',
        image: '/assets/icons/casino/provider/yeebet.png',
        icon: '/assets/icons/casino/provider/yeebet-card.svg',
        key: 'yeebet',
        sub: 'yeebet',
    },
    ['via']: {
        id: 'via',
        name: 'VIA',
        link: '/games/game_cards?partner=via',
        image: '/assets/icons/casino/provider/via.png',
        icon: '',
        key: 'via',
        sub: 'via',
    },
    ['techplay']: {
        id: 'techplay',
        name: 'Techplay',
        link: '/games/slots?partner=techplay',
        image: '/assets/img/slot/techplay.png',
        icon: '/assets/img/slot/techplay.svg',
        key: 'techplay',
        sub: 'techplay',
    },
    ['redtiger']: {
        id: 'redtiger',
        name: 'Red Tiger',
        link: '/games/slots?partner=redtiger',
        image: '/assets/img/slot/redTiger.png',
        icon: '/assets/img/slot/red_tiger.svg',
        key: 'redtiger',
        sub: 'redtiger',
    },
    ['redTiger']: {
        id: 'redtiger',
        name: 'Red Tiger',
        link: '/games/slots?partner=redTiger',
        image: '/assets/img/slot/redTiger.png',
        icon: '/assets/img/slot/red_tiger.svg',
        key: 'redtiger',
        sub: 'redtiger',
    },

    ['microgaming']: {
        id: 'microgaming',
        name: 'Microgaming',
        link: '/games/slots?partner=microgaming',
        image: '/assets/img/slot/microgaming.png',
        icon: '/assets/img/slot/microgaming.svg',
        key: 'microgaming',
        sub: 'microgaming',
        stt: 5,
    },
    ['pgsoft']: {
        id: 'pgsoft',
        name: 'PGSOFT',
        link: '/games/slots?partner=pgsoft',
        image: '/assets/img/slot/pgsoft.png',
        icon: '/assets/img/slot/pgsoft.svg',
        key: 'pgsoft',
        sub: 'pgsoft',
        stt: 4,
    },
    ['qtech']: {
        id: 'qtech',
        name: 'Qtech',
        link: '/games/slots?partner=qtech',
        image: '/assets/img/slot/qtech.png',
        icon: '/assets/img/slot/qtech.svg',
        key: 'qtech',
        sub: 'qtech',
        stt: 4,
    },
    ['playngo']: {
        id: 'playngo',
        name: `PLAY'N GO`,
        link: '/games/slots?partner=playngo',
        image: '/assets/img/slot/playngo.png',
        icon: '/assets/img/slot/playngo.svg',
        key: 'playngo',
        sub: 'playngo',
        status: '',
    },
    ['evoplay']: {
        id: 'evoplay',
        name: 'Evoplay',
        link: '/games/slots?partner=evoplay',
        image: '/assets/img/slot/evoplay.png',
        icon: '/assets/img/slot/evoplay.svg',
        key: 'evoplay',
        sub: 'evoplay',
        status: '',
    },
    ['habanero']: {
        id: 'habanero',
        name: 'Habanero',
        link: '/games/slots?partner=habanero',
        image: '/assets/img/slot/habanero.png',
        icon: '/assets/img/slot/habanero.svg',
        key: 'habanero',
        sub: 'habanero',
    },
    ['cq9']: {
        id: 'cq9',
        name: '',
        link: '/games/slots?partner=cq9',
        image: '/assets/img/slot/cq9.png',
        icon: '/assets/img/slot/cq9.svg',
        nameMb: 'CQ9',
        key: 'cq9',
        sub: 'slots',
    },
    ['digmaan']: {
        id: 'digmaan',
        name: 'Digmaan',
        link: '/games/slots?partner=digmaan',
        image: '/assets/img/slot/digmaan.png',
        icon: '/assets/img/slot/digmaan-icon.png',
        key: 'digmaan',
        nameMb: 'Digmaan',
        sub: 'digmaan',
    },
    ['jdbmaxx']: {
        id: 'jdbmaxx',
        name: 'JDBMaxx',
        link: '/games/slots?partner=jdbmaxx',
        image: '/assets/img/slot/jdbmaxx.png',
        icon: '/assets/img/slot/jdbmaxx.svg',
        key: 'jdbmaxx',
        sub: 'jdbmaxx',
    },
    ['jdb']: {
        id: 'jdb',
        name: 'JDB',
        link: '/games/slots?partner=jdb',
        image: '/assets/img/slot/jdb.png',
        icon: '/assets/img/slot/jdb.png',
        key: 'jdb',
        sub: 'jdb',
        stt: 4,
    },
    ['onegame']: {
        id: 'onegame',
        name: 'One Game',
        link: '/games/slots?partner=onegame',
        image: '/assets/img/slot/onegame.png',
        icon: '/assets/img/slot/onegame.svg',
        key: 'onegame',
    },
    ['wazdan']: {
        id: 'wazdan',
        name: 'Wazdan',
        link: '/games/slots?partner=wazdan',
        image: '/assets/img/slot/wazdan.png',
        icon: '/assets/img/slot/wazdan.svg',
        key: 'wazdan',
    },
    ['spinomenal']: {
        id: 'spinomenal',
        name: 'Spinomenal',
        link: '/games/slots?partner=spinomenal',
        image: '/assets/img/slot/spinomenal.png',
        icon: '/assets/img/slot/spinomenal.svg',
        key: 'spinomenal',
        sub: 'spinomenal',
    },
    ['im-sports']: {
        id: 'im-sports',
        name: 'Im',
        link: '/im-sports',
        image: '/assets/icons/casino/provider/im.png',
        icon: '/assets/icons/casino/provider/im.svg',
        key: 'im-sports',
        sub: 'im-sports',
        status: '',
    },
    ['athena']: {
        id: 'athena',
        name: 'Saba',
        link: '/athena/sportUrl',
        image: '/assets/icons/casino/provider/t-sport.png',
        icon: '/assets/icons/casino/provider/athena.svg',
        key: 'athena',
    },
    ['bti']: {
        id: 'bti',
        name: 'BTI',
        link: '/athena/sportUrl',
        image: '/assets/icons/casino/provider/a-sport.png',
        imgBg: '/assets/img/sport/a-sport.png',
        imgLg: '/assets/img/sport/a-sport-mb.png',
        imgMb: '/assets/img/sport/a-sport-avatar.png',
        title: 'bti-sport',
        icon: '/assets/icons/casino/provider/a-sport.svg',
        key: 'bti',
        sub: 'bti',
    },
    ['betradar']: {
        id: 'betradar',
        name: 'BETRADAR',
        link: '/betradar-sports',
        linkVirtual: '/betradar-sports',
        image: '/assets/icons/casino/provider/s-sport.png',
        imageVirtual: '/assets/img/sport/s_play.png',
        imgBg: '/assets/img/sport/s-sport.png',
        imgLg: '/assets/img/sport/s-sport-mb.png',
        imgMb: '/assets/img/sport/s-sport-avatar.png',
        title: 'bti-sport',
        icon: '/assets/icons/casino/provider/s-sport.svg',
        key: 'betradar-sport',
        sub: 'betradar-sport',
    },
    ['saba']: {
        id: 'saba',
        name: 'SABA',
        link: '/athena/sportUrl',
        linkVirtual: '/saba-sports',
        image: '/assets/icons/casino/provider/t-sport-new.png',
        imageVirtual: '/assets/img/sport/saba-sport-v.png',
        imgBg: '/assets/img/sport/t-sport.png',
        imgLg: '/assets/img/sport/t-sport-mb.png',
        imgMb: '/assets/img/sport/t-sport-avatar.png',
        title: 'saba-sport',
        icon: '/assets/icons/casino/provider/t-sport.svg',
        key: 'saba-sport',
        sub: 'saba',
    },
    ['ksport']: {
        id: 'ksport',
        name: 'K-SPORT',
        link: '/tp/ksportUrl',
        linkVirtual: '/ksports?isvirtual=true',
        image: '/assets/icons/casino/provider/k-sport.png',
        imageVirtual: '/assets/img/sport/k-sport-v.png',
        imgBg: '/assets/img/sport/k-sport.png',
        imgLg: '/assets/img/sport/k-sport-mb.png',
        imgMb: '/assets/img/sport/k-sport-avatar.png',
        title: 'sport',
        icon: '/assets/icons/casino/provider/k-sport.svg',
        key: 'ksport',
        sub: 'ksport',
    },
    ['im']: {
        id: 'im-sports',
        name: 'Im',
        link: '/im-sports',
        image: '/assets/icons/casino/provider/im.png',
        icon: '/assets/icons/casino/provider/im.svg',
        key: 'im-sports',
        sub: 'im-sports',
        status: '',
    },
    ['in_play']: {
        id: 'in_play',
        linkVirtual: '/in-play',
        title: 'sport',
        name: 'saba',
        link: '/saba-sports',
        image: '/assets/icons/casino/provider/saba.png',
        imageVirtual: '/assets/img/sport/in_play.png',
        icon: '/assets/icons/casino/provider/saba.svg',
        key: 'in_play',
        sub: 'in_play',
    },
    ['netent']: {
        id: 'netent',
        name: 'Netent',
        link: '/games/tables?partner=netent',
        image: '/assets/img/slot/netent.png',
        icon: '/assets/img/slot/netent.svg',
        key: 'netent',
        sub: 'netent',
    },
    ['jili']: {
        id: 'jili',
        name: 'Jili',
        link: '/games/tables?partner=jili',
        image: '/assets/img/slot/jili.png',
        icon: '/assets/img/slot/jili-icon.png',
        key: 'jili',
        sub: 'jili',
        stt: 2,
        status: '',
    },
    ['fachai']: {
        id: 'fachai',
        name: 'Fachai',
        link: '/games/fishing?partner=fachai',
        image: '/assets/img/slot/fachai.png',
        icon: '/assets/img/slot/fachai.svg',
        key: 'fachai',
        sub: 'fachai',
        stt: 3,
    },
    ['spribe']: {
        id: 'spribe',
        name: 'Spribe',
        link: '/games/instants?partner=spribe',
        image: '/assets/icons/casino/provider/spribe.png',
        icon: '/assets/icons/casino/provider/spribe.svg',
        key: 'spribe',
        sub: 'spribe',
    },
    ['ibc']: {
        id: 'ibc',
        name: 'IBC',
        link: '/games/lotto?partner=ibc',
        image: '/assets/icons/casino/provider/quick-games/ibc.png',
        icon: '/assets/icons/casino/provider/ibc-icon.png',
        key: 'ibc',
        sub: 'ibc',
    },
    ['askmelotto']: {
        id: 'askmelotto',
        name: 'AskMeLotto',
        link: '/games/lotto?partner=askmelotto',
        image: '/assets/icons/casino/provider/askmelotto.png',
        icon: '/assets/icons/casino/provider/askmelotto-active.svg',
        key: 'askmelotto',
        sub: 'askmebet',
        status: '',
    },
    ['kingmaker']: {
        id: 'kingmaker',
        name: 'Kingmaker',
        link: '/casino/all?partner=kingmaker',
        image: '/assets/icons/casino/provider/live-casino/kingmaker.png',
        icon: '/assets/icons/casino/provider/kingmaker-active.svg',
        key: 'kingmaker',
        sub: 'kingmaker',
        status: '',
    },
    ['dreamgaming']: {
        id: 'dreamgaming',
        name: 'Dreamgaming',
        link: '/casino/all?partner=dreamgaming',
        image: '/assets/icons/casino/provider/live-casino/dreamgaming.png',
        icon: '/assets/icons/casino/provider/dreamgaming-active.svg',
        key: 'dreamgaming',
        sub: 'dreamgaming',
        status: '',
    },
}

export const useProviderStore = defineStore('providerStore', () => {
    const providersByType = ref({})
    const fetcher = useCustomFetch()
    const initProviders = async () => {
        try {
            const { data, error } = await fetcher.get('/provider')
            if (data.value.status !== 'OK') {
                throw error
            }
            const responseData = data?.value?.data
            for (const [type, providers] of Object.entries(responseData)) {
                providersByType.value[apiProviderAdapters[type] || type] =
                    providers
                        .map((item) => {
                            if (PROVIDERS[item.key]?.id === undefined) {
                                return
                            }

                            let link = PROVIDERS[item.key]?.link || ''
                            let image = PROVIDERS[item.key]?.image || ''

                            if (type === 'fishing') {
                                link = `/games/fishing?partner=${
                                    PROVIDERS[item.key]?.id
                                }`
                                image = `/assets/icons/casino/provider/fishing/${
                                    PROVIDERS[item.key]?.id
                                }.png`
                            }
                            if (type === 'table_game') {
                                link = `/games/tables?partner=${
                                    PROVIDERS[item.key]?.id
                                }`
                                image = `/assets/icons/casino/provider/table-game/${
                                    PROVIDERS[item.key]?.id
                                }.png`
                            }
                            if (type === 'slots') {
                                link = `/games/slots?partner=${
                                    PROVIDERS[item.key]?.id
                                }`
                                image = PROVIDERS[item.key].image
                            }
                            if (type === 'lotto') {
                                link = `/games/lottery?partner=${
                                    PROVIDERS[item.key]?.id
                                }`
                                image = `/assets/icons/casino/provider/lottery/${
                                    PROVIDERS[item.key]?.id
                                }.png`
                            }
                            if (type === 'quick_game') {
                                link = `/games/instants?partner=${
                                    PROVIDERS[item.key]?.id
                                }`
                                image = `/assets/img/games/q_mb_${
                                    PROVIDERS[item.key]?.id
                                }.png`
                            }
                            if (type === 'live_casino') {
                                link = `casino/all?partner=${
                                    PROVIDERS[item.key]?.id
                                }`
                                image = `/assets/icons/casino/provider/live-casino/${
                                    PROVIDERS[item.key]?.id
                                }.png`
                            }
                            return {
                                ...PROVIDERS[item.key],
                                link,
                                image,
                                label: item?.label,
                            }
                        })
                        .filter((item) => !!item)
            }
        } catch (err) {
            console.log('providerStore', err)
        }
    }

    const commonAll = {
        id: '',
        key: '',
        name: 'provider.all',
    }

    const sportProviderComputed = computed(() => {
        return providersByType.value['sport']?.filter((item) => !!item) || []
    })
    const virtualProviderComputed = computed(
        () =>
            providersByType.value['virtual_sport']?.filter((item) => !!item) ||
            []
    )

    const liveCasinoProviderComputed = computed(() =>
        providersByType.value['live_casino']?.filter((item) => !!item)
    )

    const liveCasinoProviderAllComputed = computed(() => [
        commonAll,
        ...(providersByType.value['live_casino']?.filter((item) => !!item) ||
            []),
    ])

    const esportProviderComputed = computed(() => {
        return providersByType.value['e-sport']?.filter((item) => !!item) || []
    })

    function getGamesProvidersByType(type) {
        let key = type
        if (type === 'tables') key = 'table_game'
        if (type === 'instants') key = 'quick_game'
        return providersByType.value[key]
    }
    function getGamesProvidersAllByType(type) {
        let key = type
        if (type === 'cockfight') return []
        if (type === 'tables') key = 'table_game'
        if (type === 'instants') key = 'quick_game'

        return [commonAll, ...(providersByType.value[key] || [])]
    }

    return {
        initProviders,
        providersByType,
        sportProviderComputed,
        liveCasinoProviderComputed,
        liveCasinoProviderAllComputed,
        esportProviderComputed,
        getGamesProvidersByType,
        getGamesProvidersAllByType,
        virtualProviderComputed,
    }
})
